import Vue from 'vue'

import Router from 'vue-router'

/* Layout */

import Layout from '@/layout'

Vue.use(Router)

export const constantRoutes = [

  {

    path: '/login',

    component: () => import('@/views/login/index'),

    hidden: true

  },

  {

    path: '/404',

    component: () => import('@/views/404'),

    hidden: true

  },

  {

    path: '/register',

    component: () => import('@/views/login/register'),

    hidden: true

  },

  {

    path: '/forgot-password',

    component: () => import('@/views/login/forgot-password.vue'),

    hidden: true

  },

  {

    path: '/unit-info',

    component: () => import('@/views/user/UnitInfo'),

    hidden: true

  },

  {

    path: '/course-required',

    component: () => import('@/views/user/CourseRequired'),

    hidden: true

  },

  {

    path: '/sms-test',

    component: () => import('@/views/SmsTest.vue'),

    hidden: true

  },

  {

    path: '/subject-select',

    component: () => import('@/views/SubjectSelect.vue'),

    hidden: true,

    meta: { title: '选择学习科目' }

  },

  {

    path: '/',

    name: 'Landing',

    component: () => import('@/views/Landing.vue'),

    hidden: true

  },

  {

    path: '/landing',

    name: 'LandingPage',

    component: () => import('@/views/Landing.vue'),

    hidden: true

  },

  {

    path: '/user-profile',

    name: 'UserProfile',

    component: () => import('@/views/user/UserProfile.vue'),

    hidden: true,

    meta: { title: '个人信息' }

  },

  {

    path: '/competition-archive',

    name: 'CompetitionArchive',

    component: () => import('@/views/competition/CompetitionArchive.vue'),

    hidden: true,

    meta: { title: '竞赛档案' }

  },

  {

    path: '/dashboard',

    component: Layout,

    meta: { requireAuth: true },

    redirect: '/dashboard', // 修改重定向路径

    children: [{

      path: '',

      name: 'Dashboard',

      component: () => import('@/views/dashboard/index'),

      meta: { title: '主页', icon: 'el-icon-data-line', visible: true }

    }]

  },

  {

    path: '/ai-search',

    component: Layout,

    children: [{

      path: '/ai-search',

      name: 'ai-search',

      component: () => import('@/views/ai/search'),

      meta: { title: 'AI搜题', visible: true, roles: ['student', 'teacher', 'admin', 'parent'], icon: 'el-icon-search' }

    }]

  },

  {

    path: '/course',

    component: Layout,

    children: [{

      path: 'selection',

      name: 'CourseSelection',

      component: () => import('@/views/course/CourseSelection'),

      hidden: true, // 保留hidden属性以隐藏侧边栏

      meta: {

        title: '选课中心',

        icon: 'el-icon-reading',

        visible: true,

        roles: ['student', 'admin', 'mteacher']

      }

    }]

  },

  {

    path: '/course/detail/:id',

    name: 'CourseDetail',

    component: () => import('@/views/course/CourseDetail'),

    hidden: true,

    meta: {

      title: '课程详情',

      icon: 'el-icon-s-help',

      // visible: true,

      roles: ['student', 'admin', 'mteacher', 'teacher']

    }

  },

  {

    path: '/course/:courseId/exam/:examId',

    name: 'ExamDetail',

    component: () => import('@/views/course/exam/ExamDetail'),

    hidden: true,

    meta: {

      title: '试卷详情',

      icon: 'el-icon-document',

      roles: ['student', 'admin', 'mteacher', 'teacher']

    }

  },

  {

    path: '/teacher-course/:id',

    name: 'TeacherCourseDetail',

    component: () => import('@/views/course/AMCTeacherCourseDetail.vue'),

    hidden: true,

    meta: {

      title: '教师课程详情',

      icon: 'el-icon-reading',

      roles: ['teacher', 'admin', 'mteacher']

    }

  },

  {

    path: '/amc/teacher-course/:id',

    redirect: to => {
      const { id } = to.params

      return `/teacher-course/${id}`
    },

    hidden: true

  },

  {

    path: '/course/teacher/:id',

    redirect: to => {
      const { id } = to.params

      return `/teacher-course/${id}`
    },

    hidden: true

  },

  {

    path: '/course-management',

    component: Layout,

    // hidden: true,

    children: [{

      path: 'index',

      name: 'CourseManagement',

      component: () => import('@/views/course/CourseManagement'),

      meta: {

        title: '我的课程',

        icon: 'el-icon-reading',

        visible: true,

        roles: ['student', 'teacher', 'admin']

      }

    }, {

      path: 'resource-management',

      name: 'CourseResourceManagement',

      hidden: true,

      component: () => import('@/views/course/CourseResourceManagement'),

      meta: {

        title: '课程资料管理',

        icon: 'el-icon-folder',

        visible: true,

        roles: ['teacher', 'admin', 'mteacher']

      }

    }, {

      path: 'resource-view',

      name: 'CourseResourceView',

      hidden: true,

      component: () => import('@/views/course/CourseResourceView'),

      meta: {

        title: '课程资料',

        icon: 'el-icon-document',

        visible: true,

        roles: ['student', 'parent']

      }

    }]

  },

  {

    path: '/homework',

    component: Layout,

    meta: { title: '作业汇总', icon: 'el-icon-document', visible: true, roles: ['student', 'parent'] },

    children: [

      {

        path: '',

        name: 'Homework',

        component: () => import('@/views/homework/index'),

        meta: { title: '作业汇总', icon: 'el-icon-document', visible: true, roles: ['student'] }

      }

    ]

  },

  {

    path: '/user-management',

    component: Layout,

    children: [{

      path: '/user-management',

      name: 'user-management',

      component: () => import('@/views/admin/index'),

      meta: { title: '用户管理', icon: 'el-icon-user', visible: true, roles: ['admin'] }

    }]

  },

  {

    path: '/myself',

    component: Layout,

    children: [{

      path: '/myself',

      name: 'myself',

      hidden: true,

      component: () => import('@/views/user/myself'),

      meta: { title: '个人中心', visible: true, roles: ['teacher', 'admin', 'student'], icon: 'dashboard' }

    }]

  },

  {

    path: '/change-password',

    component: Layout,

    children: [{

      path: '/change-password',

      name: 'change-password',

      hidden: true,

      component: () => import('@/views/user/updatePassword.vue'),

      meta: { title: '修改密码', visible: true, roles: ['teacher', 'admin', 'student', 'mteacher'], icon: 'dashboard' }

    }]

  },

  {

    path: '/class-management',

    component: Layout,

    children: [{

      path: '/class-management',

      name: 'class-management',

      component: () => import('@/views/class/index'),

      hidden: true,

      meta: { title: '班级管理', visible: true, roles: ['teacher', 'admin'], icon: 'el-icon-takeaway-box' }

    }]

  },

  {

    path: '/homework-correct',

    component: Layout,

    hidden: true,

    meta: { title: '作业管理', visible: true, roles: ['teacher'], icon: 'el-icon-files' },

    children: [{

      path: 'homework-correct',

      name: 'homework-correct',

      component: () => import('@/views/homework/correct'),

      hidden: true,

      // component: () => import('@/views/homework/HomeworkCorrectPanel'),

      // , 'admin'

      meta: { title: '作业管理', visible: true, roles: ['teacher'], icon: 'el-icon-files' }

    },

    {

      path: 'batchUpload',

      name: 'batchUpload',

      hidden: true,

      component: () => import('@/views/homework/batchUpload'),

      meta: { title: '批量上传', visible: true, roles: ['teacher'], icon: 'el-icon-upload' }

    },

    {

      path: 'student-upload/:id',

      name: 'BatchStudentUpload',

      component: () => import('@/views/homework/BatchStudentUpload'),

      meta: { title: '学生作业批量上传', visible: false, roles: ['teacher'], icon: 'el-icon-upload' },

      hidden: true

    }

    ]

  },

  {

    path: '/text-center',

    component: Layout,

    children: [{

      path: '/text-center',

      name: 'text-center',

      component: () => import('@/views/exam/student/index'),

      meta: { title: '考试中心', visible: true, roles: ['student'], icon: 'el-icon-document-copy' }

    }]

  },

  {

    path: '/prepare-exam',

    component: Layout,

    children: [{

      path: '/prepare-exam',

      name: 'prepare-exam',

      hidden: true,

      component: () => import('@/views/exam/examInformation.vue'),

      meta: { title: '准备考试', visible: true, roles: ['teacher', 'admin', 'student'], icon: 'dashboard' }

    }]

  },

  {

    path: '/start-exam',

    name: 'start-exam',

    hidden: true,

    component: () => import('@/views/exam/index.vue'),

    meta: { title: '开始考试', visible: true, roles: ['teacher', 'admin', 'student'], icon: 'dashboard' }

  },

  // {

  //   path: '/exercise-center',

  //   component: Layout,

  //   children: [{

  //     path: '/exercise-center',

  //     name: 'exercise-center',

  //     component: () => import('@/views/exercise/index'),

  //     // 'admin',

  //     meta: { title: '刷题中心', visible: true, roles: ['student'], icon: 'el-icon-tickets' }

  //   }]

  // },

  {

    path: '/start-exercise',

    name: 'start-exercise',

    hidden: true,

    component: () => import('@/views/exercise/exercise.vue'),

    meta: { title: '开始刷题', visible: true, roles: ['teacher', 'admin', 'student'], icon: 'dashboard' }

  },

  {

    path: '/record',

    component: Layout,

    name: 'record',

    // 'admin',

    meta: { title: '考试记录', icon: 'el-icon-folder-opened', visible: true, roles: ['student', 'parent'], requireAuth: true },

    children: [

      {

        path: '/exam-record',

        name: 'exam-record',

        component: () => import('@/views/record/exam/index.vue'),

        // 'admin',

        meta: { title: '考试记录', visible: true, roles: ['student'], icon: 'table' }

      }

      // {

      //   path: '/exam-analysis',

      //   name: 'exam-analysis',

      //   component: () => import('@/views/record/exam/analysis.vue'),

      //   // 'admin',

      //   meta: { title: '考试分析', visible: true, roles: ['student'], icon: 'table' }

      // },

      // {

      //   path: '/exercise-record',

      //   name: 'exercise-record',

      //   // 'admin',

      //   component: () => import('@/views/record/exercise/index.vue'),

      //   meta: { title: '刷题记录', visible: true, roles: ['student'], icon: 'tree' }

      // }

    ]

  },

  {

    path: '/exam-record-detail',

    component: Layout,

    children: [{

      path: '/exam-record-detail',

      name: 'exam-record-detail',

      hidden: true,

      component: () => import('@/views/record/exam/StudentExamDetail'),

      meta: { title: '考试记录查看', visible: true, roles: ['teacher', 'admin', 'student'], icon: 'dashboard' }

    }]

  },

  {

    path: '/exam-schedule-management',

    component: Layout,

    children: [{

      path: '/exam-schedule-management',

      name: 'ExamScheduleManagement',

      component: () => import('@/views/admin/ExamScheduleManagement.vue'),

      meta: { title: '备考时间管理', visible: true, roles: ['admin'], icon: 'el-icon-date' }

    }]

  },

  {

    path: '/parent-competition-archive',

    component: Layout,

    children: [{

      path: 'competition-archive',

      name: 'ParentCompetitionArchive',

      component: () => import('@/views/competition/CompetitionArchiveManagement.vue'),

      meta: { title: '学生资料查看', visible: true, roles: ['parent'], icon: 'el-icon-reading' }

    }]

  },

  {

    path: '/org-competition-archive',

    component: Layout,

    children: [{

      path: '/org/competition-archive',

      name: 'OrgCompetitionArchive',

      component: () => import('@/views/competition/CompetitionArchiveManagement.vue'),

      meta: { title: '资料查验', visible: true, roles: ['organization'], icon: 'el-icon-document-checked' }

    }]

  },

  // {

  //   path: '/exercise-record-detail',

  //   component: Layout,

  //   children: [{

  //     path: '/exercise-record-detail',

  //     name: 'exercise-record-detail',

  //     hidden: true,

  //     component: () => import('@/views/record/exercise/newk'),

  //     meta: { title: '刷题记录查看', visible: true, roles: ['teacher', 'admin', 'student'], icon: 'dashboard' }

  //   }]

  // },

  // {

  //   path: '/userbook',

  //   component: Layout,

  //   children: [

  //     {

  //       path: '',

  //       name: 'userbook-overview',

  //       component: () => import('@/views/userbook/overview.vue'),

  //       meta: { title: '错题本总览', visible: false }

  //     },

  //     {

  //       path: 'list',

  //       name: 'userbook-list',

  //       component: () => import('@/views/userbook/index.vue'),

  //       meta: { title: '错题本列表', visible: false }

  //     }

  //   ]

  // },

  {

    path: '/userbook',

    component: Layout,

    children: [

      {

        path: '',

        name: 'UserbookOverview',

        component: () => import('@/views/userbook/UserbookOverview.vue'),

        meta: { title: '错题本总览', visible: false }

      },

      {

        path: 'list',

        name: 'UserbookSubjectDetail',

        component: () => import('@/views/userbook/UserbookSubjectDetail.vue'),

        meta: { title: '错题本列表', visible: false }

      }

    ]

  },

  {

    path: '/wrong-book',

    component: Layout,

    children: [{

      path: '/wrong-book',

      name: 'wrong-book',

      component: () => import('@/views/userbook/UserbookOverview.vue'),

      meta: { title: '错题本', visible: true, roles: ['student'], icon: 'el-icon-notebook-1' }

    }]

  },

  {

    path: '/rebrush',

    name: 'rebrush',

    hidden: true,

    component: () => import('@/views/userbook/rebrush.vue'),

    meta: { title: '重刷', visible: true, roles: ['teacher', 'admin', 'student'], icon: 'dashboard' }

  },

  {

    path: '/exam-management',

    component: Layout,

    children: [{

      path: '/exam-management',

      name: 'exam-management',

      component: () => import('@/views/exam/teacher/index'),

      hidden: true,

      // , 'admin'

      meta: { title: '考试管理', visible: true, roles: ['teacher', 'admin'], icon: 'el-icon-document' }

    }]

  },

  {

    path: '/answer-manage',

    component: Layout,

    // hidden: true,

    children: [{

      path: 'marking-management',

      name: 'marking-management',

      component: () => import('@/views/answer/index'),

      hidden: true,

      // , 'admin'

      meta: { title: '阅卷管理', visible: true, roles: ['teacher'], icon: 'el-icon-files' }

    }]

  },

  {

    path: '/exam-add',

    component: Layout,

    children: [{

      path: '/exam-add',

      name: 'exam-add',

      hidden: true,

      component: () => import('@/views/exam/examAdd'),

      meta: { title: '考试添加', visible: true, roles: ['teacher', 'admin'], icon: 'dashboard' }

    }]

  },

  {

    path: '/repo-management',

    component: Layout,

    children: [{

      path: '/repo-management',

      name: 'repo-management',

      component: () => import('@/views/repo/index'),

      meta: { title: '题库管理', visible: true, roles: ['teacher', 'admin'], icon: 'el-icon-folder-opened' }

    }]

  },

  {

    path: '/questions-management',

    component: Layout,

    hidden: true,

    children: [{

      path: '/questions-management',

      name: 'questions-management',

      component: () => import('@/views/question/index'),

      meta: { title: '试题管理', visible: true, roles: ['teacher', 'admin'], icon: 'el-icon-document-copy' }

    }]

  },

  {

    path: '/questions-add',

    component: Layout,

    children: [{

      path: '/questions-add',

      name: 'questions-add',

      hidden: true,

      component: () => import('@/views/question/add.vue'),

      meta: { title: '试题添加', visible: true, roles: ['teacher', 'admin'], icon: 'dashboard' }

    }]

  },

  {

    path: '/questions-amc-add',

    component: Layout,

    children: [{

      path: '/questions-amc-add',

      name: 'questions-amc-add',

      hidden: true,

      component: () => import('@/views/question/AMCAdd.vue'),

      meta: { title: '试题录入', visible: true, roles: ['teacher', 'admin'], icon: 'dashboard' }

    }]

  },

  {

    path: '/AMCexercise',

    component: Layout,

    // hidden: true,

    children: [{

      path: '/AMCexercise',

      name: 'AMCexercise',

      // hidden: true,

      component: () => import('@/views/exercise/AMCexercise.vue'),

      meta: { title: 'AMC练习', visible: true, roles: ['student'], icon: 'el-icon-edit-outline' }

    }]

  },

  {

    path: '/amc-level-select',

    component: Layout,

    hidden: true,

    children: [{

      path: '/amc-level-select',

      name: 'AMCLevelSelect',

      component: () => import('@/views/course/AMCLevelSelect.vue'),

      meta: { title: '选择AMC级别', visible: false, roles: ['student'], icon: 'el-icon-trophy', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/amc-course',

    component: Layout,

    hidden: true,

    children: [{

      path: '/amc-course',

      name: 'AMCCourse',

      component: () => import('@/views/course/AMCCourse.vue'),

      meta: { title: 'AMC备考中心', visible: true, roles: ['student'], icon: 'el-icon-trophy', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/app-download',

    component: Layout,

    hidden: true,

    children: [{

      path: '/app-download',

      name: 'AppDownload',

      component: () => import('@/views/course/AppDownload.vue'),

      meta: { title: '下载App', visible: false, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/amc-classroom',

    component: Layout,

    hidden: true,

    children: [{

      path: '/amc-classroom',

      name: 'AmcClassroom',

      component: () => import('@/views/course/AmcClassroom.vue'),

      meta: { title: '课堂', visible: true, roles: ['student'], icon: 'el-icon-s-home', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/kangaroo-course',

    redirect: (to) => ({ path: '/amc-course', query: to.query || {} }),

    hidden: true

  },

  {

    path: '/amc-plan-details',

    component: Layout,

    hidden: true,

    children: [{

      path: '/amc-plan-details',

      name: 'AMCPlanDetails',

      component: () => import('@/views/course/AMCPlanDetails.vue'),

      meta: { title: '备考计划详情', visible: false, roles: ['student'], icon: 'el-icon-timer', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/amc-past-papers',

    component: Layout,

    hidden: true,

    children: [{

      path: '/amc-past-papers',

      name: 'AMCPastPapers',

      component: () => import('@/views/course/AMCPastPapers.vue'),

      meta: { title: '历年真题', visible: true, roles: ['student'], icon: 'el-icon-document', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/amc-knowledge',

    component: Layout,

    hidden: true,

    children: [{

      path: '/amc-knowledge',

      name: 'AMCKnowledge',

      component: () => import('@/views/course/KnowledgeBase.vue'),

      meta: { title: 'AMC知识库', visible: true, roles: ['student', 'teacher', 'admin', 'mteacher'], icon: 'el-icon-collection', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/amc-mock-test',

    component: Layout,

    hidden: true,

    children: [{

      path: '/amc-mock-test',

      name: 'AMCMockTest',

      component: () => import('@/views/course/AMCMockTest.vue'),

      meta: { title: '模拟考试', visible: true, roles: ['student'], icon: 'el-icon-edit', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/gesp-mock-test',

    component: Layout,

    hidden: true,

    children: [{

      path: '/gesp-mock-test',

      name: 'GESPMockTest',

      component: () => import('@/views/gesp/GESPMockTest.vue'),

      meta: { title: 'GESP模拟考试', visible: true, roles: ['student'], icon: 'el-icon-edit', hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/amc-profile',

    component: Layout,

    hidden: true,

    children: [{

      path: '/amc-profile',

      name: 'AmcProfile',

      component: () => import('@/views/user/AmcProfile.vue'),

      meta: { title: '个人中心', visible: false, roles: ['student'], icon: 'el-icon-user', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/gesp-practice',

    component: Layout,

    hidden: true,

    children: [{

      path: '/gesp-practice',

      name: 'GESPPractice',

      component: () => import('@/views/gesp/GESPPractice.vue'),

      meta: { title: 'GESP答题', visible: false, roles: ['student'], icon: 'el-icon-edit', hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/gesp-code-list',

    component: Layout,

    hidden: true,

    children: [{

      path: '/gesp-code-list',

      name: 'GESPCodeList',

      component: () => import('@/views/gesp/GESPCodeList.vue'),

      meta: { title: 'GESP编程题', visible: false, roles: ['student'], icon: 'el-icon-document', hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/gesp-code-manage',

    component: Layout,

    hidden: true,

    children: [{

      path: '/gesp-code-manage',

      name: 'GESPCodeManage',

      component: () => import('@/views/gesp/GESPCodeManage.vue'),

      meta: { title: 'GESP编程题管理', visible: false, roles: ['admin', 'teacher', 'mteacher'] }

    }]

  },

  {

    path: '/gesp-code-detail',

    component: Layout,

    hidden: true,

    children: [{

      path: '/gesp-code-detail',

      name: 'GESPCodeDetail',

      component: () => import('@/views/gesp/GESPCodeDetail.vue'),

      meta: { title: 'GESP编程题详情', visible: false, roles: ['student'], icon: 'el-icon-edit-outline', hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  // {

  //   path: '/certificate',

  //   component: Layout,

  //   children: [{

  //     path: '/certificate-management',

  //     name: 'certificate-management',

  //     component: () => import('@/views/certificate/CertMgr'),

  //     meta: { title: '证书管理', visible: true, roles: ['admin', 'mteacher'], icon: 'el-icon-postcard' }

  //   }]

  // },

  // {

  //   path: '/mycertificate',

  //   component: Layout,

  //   children: [{

  //     path: '/mycertificate',

  //     name: 'mycertificate',

  //     component: () => import('@/views/certificate/myCertificates'),

  //     // 'admin',

  //     meta: { title: '我的证书', icon: 'el-icon-postcard', visible: true, roles: ['student'] }

  //   }]

  // },

  {

    path: '/score-analysis',

    component: Layout,

    meta: { title: '学情分析', visible: true, roles: ['teacher', 'mteacher', 'parent'], icon: 'el-icon-pie-chart' },

    hidden: true,

    children: [{

      path: 'overview',

      name: 'overview',

      hidden: true,

      component: () => import('@/views/score/analysis'),

      meta: { title: '成绩分析', visible: true, roles: ['teacher', 'mteacher', 'parent'], icon: 'el-icon-pie-chart' }

    },

    {

      path: 'exam-analysis',

      name: 'exam-analysis',

      component: () => import('@/views/record/exam/analysis.vue'),

      meta: { title: '试卷分析', visible: true, roles: ['teacher', 'mteacher', 'parent'], icon: 'el-icon-pie-chart' }

    },

    {

      path: 'paper-analysis',

      name: 'paper-analysis',

      component: () => import('@/views/record/exam/paperAnalysis.vue'),

      meta: { title: '班级试卷分析', visible: true, roles: ['teacher', 'mteacher', 'parent'], icon: 'el-icon-pie-chart' }

    },

    {

      path: 'score/list',

      name: 'score-list',

      hidden: true,

      component: () => import('@/views/score/index'),

      meta: { title: '成绩列表', visible: true, roles: ['teacher', 'mteacher', 'parent'], icon: 'el-icon-pie-chart' }

    },

    {

      path: 'homework-analysis',

      name: 'homework-analysis',

      component: () => import('@/views/score/indexhw'),

      meta: { title: '作业分析', visible: true, roles: ['teacher', 'mteacher', 'parent'], icon: 'el-icon-pie-chart' }

    },

    {

      path: 'homework/list',

      name: 'homework-list',

      component: () => import('@/views/score/homeworkList'),

      hidden: true,

      meta: { title: '作业列表', visible: true, roles: ['teacher', 'mteacher'], icon: 'el-icon-document' }

    },

    {

      path: 'homework/detail',

      name: 'homework-detail',

      component: () => import('@/views/score/homeworkDetail'),

      hidden: true,

      meta: { title: '作业详情', visible: true, roles: ['teacher', 'mteacher'], icon: 'dashboard' }

    }

    ]

  },

  {

    path: '/detail',

    component: Layout,

    children: [{

      path: '/user-score',

      name: 'user-score',

      hidden: true,

      component: () => import('@/views/score/detail'),

      meta: { title: '用户成绩', visible: true, roles: ['teacher', 'admin'], icon: 'dashboard' }

    }]

  },

  {

    path: '/generate',

    component: Layout,

    meta: { title: '教学工具', visible: true, roles: ['teacher', 'admin'], icon: 'el-icon-files' },

    children: [{

      path: '/GeneratePPT',

      name: 'GeneratePPT',

      hidden: true,

      component: () => import('@/views/ai/generate-ppt'),

      meta: { title: '生成PPT', visible: true, roles: ['teacher', 'admin'], icon: 'el-icon-files' }

    },

    {

      path: '/LessonPlan',

      name: 'LessonPlan',

      component: () => import('@/views/ai/lesson-plan'),

      meta: { title: '教案设计', visible: true, roles: ['teacher', 'admin'], icon: 'el-icon-files' },

      hidden: true

    },

    {

      path: '/UnitDesign',

      name: 'UnitDesign',

      component: () => import('@/views/ai/videoTutor'),

      meta: { title: 'AI助教', visible: true, roles: ['teacher', 'student', 'admin'], icon: 'el-icon-files' },

      hidden: true

    },

    {

      path: '/generatenote',

      name: 'generatenote',

      component: () => import('@/views/ai/generatenote'),

      meta: { title: '生成讲稿', visible: true, roles: ['teacher', 'admin'], icon: 'el-icon-files' }

    },

    {

      path: '/ai-dialog',

      component: Layout,

      children: [{

        path: '/ai-dialog',

        name: 'ai-dialog',

        component: () => import('@/views/ai/aiDialog'),

        meta: { title: 'AI口语教师', visible: true, roles: ['student', 'teacher', 'admin', 'parent'], icon: 'el-icon-chat-dot-round' },

        hidden: true

      }]

    },

    {

      path: '/remotemark',

      name: 'remotemark',

      component: () => import('@/views/ai/remotemark'),

      meta: { title: '去除批改痕迹', visible: true, roles: ['teacher', 'admin'], icon: 'el-icon-files' }

    }

    ]

  },

  {

    path: '/notice',

    component: Layout,

    // hidden:true,

    children: [{

      path: '/notice',

      name: 'notice',

      component: () => import('@/views/notice/notice.vue'),

      hidden: true,

      // , 'admin'

      meta: { title: '通知管理', visible: true, roles: ['teacher'], icon: 'el-icon-files' }

    }]

  },

  {

    path: '/useAI',

    component: Layout,

    children: [{

      path: '/useAI',

      name: 'useAI',

      component: () => import('@/views/ai/useAI'),

      // , 'admin'

      meta: { title: 'ai出题', visible: true, roles: ['mteacher'], icon: 'el-icon-files' }

    }]

  },

  {

    path: '/answer',

    component: Layout,

    children: [{

      path: '/answer-show',

      name: 'answer-show',

      hidden: true,

      component: () => import('@/views/answer/answerck'),

      meta: { title: '答卷查看', visible: true, roles: ['teacher', 'admin'], icon: 'dashboard' }

    }]

  },

  {

    path: '/makeTest',

    component: Layout,

    children: [{

      path: '/makeTest',

      name: 'makeTest',

      hidden: true,

      component: () => import('@/views/answer/makeTest'),

      meta: { title: '批改试卷', visible: true, roles: ['teacher', 'admin'], icon: 'dashboard' }

    }]

  },

  {

    path: '/course/notice-management',

    component: Layout,

    hidden: true,

    children: [

      {

        path: '',
        name: 'CourseNoticeManagement',

        component: () => import('@/views/course/CourseNoticeManagement'),

        meta: { title: '课程通知管理', icon: 'el-icon-bell' }

      }

    ],

    // 只对教师和管理员可见

    meta: { roles: ['teacher', 'admin', 'mteacher'] }

  },

  {

    path: '/ai',

    component: Layout,

    meta: { title: 'AI出题', visible: true, roles: ['teacher', 'student'], icon: 'el-icon-magic-stick' },

    hidden: true,

    children: [

      // {

      // path: '/homework-question',

      // name: 'homework-question',

      // component: () => import('@/views/ai/homeworkquestion'),

      // meta: { title: '作业出题', visible: true, roles: ['teacher', 'student'], icon: 'el-icon-magic-stick' }

      // },

      {

        path: '/exam-question',

        name: 'exam-question',

        component: () => import('@/views/ai/examquestion'),

        meta: { title: '考试出题', visible: true, roles: ['teacher'], icon: 'el-icon-magic-stick' },

        hidden: true

      },

      {

        path: '/exam-template',

        name: 'exam-template',

        component: () => import('@/views/ai/examTemplate.vue'),

        meta: { title: '组卷模板', visible: true, roles: ['teacher'], icon: 'el-icon-magic-stick' }

      }

    ]

  },

  {

    path: '/homework/upload',

    name: 'UploadComponent',

    component: () => import('@/views/homework/UploadComponent'),

    meta: { title: '上传作业', visible: false, roles: ['student', 'teacher'] },

    hidden: true

  },

  {

    path: '/homework/print',

    name: 'PrintComponent',

    component: () => import('@/views/homework/PrintComponent'),

    meta: { title: '打印作业', visible: false, roles: ['student', 'teacher'] },

    hidden: true

  },

  {

    path: '/online-exam/:homeworkId',

    name: 'OnlineExam',

    component: () => import('@/views/student/OnlineExam'),

    meta: { title: '在线答题', visible: false, roles: ['student'] },

    hidden: true

  },

  {

    path: '/homework/student-submission-list',

    component: Layout,

    children: [{

      path: '',

      name: 'StudentSubmissionList',

      component: () => import('@/views/homework/StudentSubmissionList'),

      meta: { title: '学生提交列表', visible: false, roles: ['teacher', 'admin'] }

    }],

    hidden: true

  },

  {

    path: '/weakknowledge',

    component: Layout,

    meta: { title: '学情分析', visible: true, roles: ['student'], icon: 'el-icon-edit' },

    children: [

      {

        path: '/weakknowledge',

        name: 'weakknowledge',

        component: () => import('@/views/weakknowledge/index'),

        meta: { title: '综合学情分析', visible: true, roles: ['student'], icon: 'el-icon-edit' }

      },

      {

        path: 'exam-analysis',

        name: 'weakknowledge-exam-analysis',

        component: () => import('@/views/weakknowledge/examAnayles'),

        meta: { title: '考试分析', visible: true, roles: ['student', 'teacher', 'admin', 'mteacher', 'parent'], icon: 'el-icon-edit' }

      },

      {

        path: 'create',

        name: 'createComponent',

        component: () => import('@/views/weakknowledge/create'),

        meta: { title: '个性作业生成', visible: true, roles: ['student', 'teacher'], icon: 'el-icon-edit' }

      }

    // {

    //   path: 'source',

    //   name: 'sourceComponent',

    //   component: () => import('@/views/weakknowledge/source'),

    //   meta: { title: '网课资源', visible: true, roles: ['student'], icon: 'el-icon-edit' }

    // }

    ]

  },

  {

    path: '/studyscheme',

    component: Layout,

    meta: { title: '网课资源', visible: true, roles: ['student'], icon: 'el-icon-edit' }

    // children: [{

    //   path: '/studyscheme',

    //   name: 'studyscheme',

    //   component: () => import('@/views/studyscheme/index'),

    //   meta: { title: '学校进度计划', visible: true, roles: ['student'], icon: 'el-icon-edit' }

    // },

    // {

    //   path: 'myscheme',

    //   name: 'myschemeComponent',

    //   component: () => import('@/views/studyscheme/myscheme'),

    //   meta: { title: '我的学情分析', visible: true, roles: ['student'], icon: 'el-icon-edit' }

    // }

    // ]

  },

  {

    path: '/points',

    component: Layout,

    meta: { title: '学习积分', visible: true, roles: ['student'], icon: 'el-icon-edit' }

    // children: [{

    //   path: '/points',

    //   name: 'points',

    //   component: () => import('@/views/points/index'),

    //   meta: { title: '积分兑换', visible: true, roles: ['student'], icon: 'el-icon-edit' }

    // }]

  },

  {

    path: '/contact',

    name: 'Contact',

    component: () => import('@/views/contact/index'),

    hidden: true,

    meta: { title: '联系我们' }

  },

  {

    path: '/intro/:type',

    name: 'ProjectIntro',

    component: () => import('@/views/intro/ProjectIntro.vue'),

    hidden: true,

    meta: { title: '项目介绍' }

  },

  {

    path: '/knowledge-management',

    component: Layout,

    children: [{

      path: '/knowledge-management',

      name: 'knowledge-management',

      component: () => import('@/views/question/KnowledgeManagement'),

      meta: { title: '知识点管理', visible: true, roles: ['admin'], icon: 'el-icon-collection-tag' }

    }]

  },

  {

    path: '/knowledge-practice',

    component: Layout,

    hidden: true,

    children: [{

      path: '/knowledge-practice',

      name: 'knowledge-practice',

      component: () => import('@/views/course/KnowledgePractice'),

      meta: { title: '知识点精练', visible: true, roles: ['student'], icon: 'el-icon-lightbulb' }

    }]

  },

  {

    path: '/daily-question',

    component: Layout,

    hidden: true,

    children: [{

      path: '/daily-question',

      name: 'daily-question',

      component: () => import('@/views/course/DailyQuestion'),

      meta: { title: '每日一题', visible: true, roles: ['student'], icon: 'el-icon-date', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/question-records',

    component: Layout,

    hidden: true,

    children: [{

      path: '/question-records',

      name: 'question-records',

      component: () => import('@/views/course/QuestionRecords'),

      meta: { title: '做题记录', visible: true, roles: ['student'], icon: 'el-icon-time', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/consecutive-challenge',

    component: Layout,

    hidden: true,

    children: [{

      path: '/consecutive-challenge',

      name: 'consecutive-challenge',

      component: () => import('@/views/course/ConsecutiveChallenge'),

      meta: { title: '连对挑战', visible: true, roles: ['student'], icon: 'el-icon-connection', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/knowledge-question-practice',

    component: Layout,

    hidden: true,

    children: [{

      path: '/knowledge-question-practice',

      name: 'knowledge-question-practice',

      component: () => import('@/views/course/KnowledgeQuestionPractice'),

      meta: { title: '题目练习', visible: true, roles: ['student'], icon: 'el-icon-edit', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/consecutive-challenge',

    name: 'ConsecutiveChallenge',

    component: () => import('@/views/course/ConsecutiveChallenge'),

    hidden: true,

    meta: { title: '连对挑战', visible: true, roles: ['student'], icon: 'el-icon-trophy' }

  },

  {

    path: '/quick-practice',

    name: 'QuickPractice',

    component: () => import('@/views/course/QuickPractice.vue'),

    hidden: true,

    meta: { title: '快速智能练习', visible: true, roles: ['student'], icon: 'el-icon-lightning' }

  },

  {

    path: '/daily-question',

    name: 'DailyQuestion',

    component: () => import('@/views/course/DailyQuestion'),

    hidden: true,

    meta: { title: '每日一题', visible: true, roles: ['student'], icon: 'el-icon-calendar' }

  },

  {

    path: '/question-records',

    name: 'QuestionRecords',

    component: () => import('@/views/course/QuestionRecords'),

    hidden: true,

    meta: { title: '做题记录', visible: true, roles: ['student'], icon: 'el-icon-document' }

  },

  {

    path: '/learning-analytics',

    name: 'LearningAnalytics',

    component: () => import('@/views/course/LearningAnalytics.vue'),

    hidden: true,

    meta: { title: '学情分析', visible: true, roles: ['student'], icon: 'el-icon-data-analysis' }

  },

  {

    path: '/wrong-questions',

    component: Layout,

    hidden: true,

    children: [{

      path: '/wrong-questions',

      name: 'wrong-questions',

      component: () => import('@/views/course/WrongQuestions.vue'),

      meta: { title: '错题集', visible: true, roles: ['student'], icon: 'el-icon-warning', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/today-wrong',

    component: Layout,

    hidden: true,

    children: [{

      path: '/today-wrong',

      name: 'today-wrong',

      component: () => import('@/views/course/TodayWrong.vue'),

      meta: { title: '今日错题', visible: true, roles: ['student'], icon: 'el-icon-warning', amc: true, hideSidebar: true, hideNavbar: true, hideTagsView: true }

    }]

  },

  {

    path: '/batch-homework',

    component: Layout,

    children: [{

      path: 'upload',

      hidden: true,

      name: 'BatchHomeworkUpload',

      component: () => import('@/views/homework/batchUpload.vue'),

      meta: { title: '批量上传作业', visible: true, roles: ['teacher', 'admin'], icon: 'el-icon-picture' }

    }]

  },

  {

    path: '/feedback-management',

    component: Layout,

    children: [{

      path: '/feedback-management',

      name: 'FeedbackManagement',

      component: () => import('@/views/admin/FeedbackManagement.vue'),

      meta: { title: '题目反馈管理', visible: true, roles: ['admin'], icon: 'el-icon-chat-line-round' }

    }]

  },

  {

    path: '/banner-management',

    component: Layout,

    children: [{

      path: '/banner-management',

      name: 'BannerManagement',

      component: () => import('@/views/admin/BannerManagement.vue'),

      meta: { title: '外部广告管理', visible: true, roles: ['admin'], icon: 'el-icon-picture-outline' }

    }]

  },

  {

    path: '/internal-banner-management',

    component: Layout,

    children: [{

      path: '/internal-banner-management',

      name: 'InternalBannerManagement',

      component: () => import('@/views/admin/InternalBannerManagement.vue'),

      meta: { title: '内部广告管理', visible: true, roles: ['admin'], icon: 'el-icon-picture-outline-round' }

    }]

  },

  {

    path: '/user-feature-management',

    component: Layout,

    children: [{

      path: '/user-feature-management',

      name: 'UserFeatureManagement',

      component: () => import('@/views/admin/UserFeatureManagement.vue'),

      meta: { title: '用户功能管理', visible: true, roles: ['admin'], icon: 'el-icon-setting' }

    }]

  },

  {

    path: '/competition-archive-management',

    component: Layout,

    children: [{

      path: '/competition-archive-management',

      name: 'CompetitionArchiveManagement',

      component: () => import('@/views/competition/CompetitionArchiveManagement.vue'),

      meta: { title: '学生资料审核', visible: true, roles: ['admin'], icon: 'el-icon-document-checked' }

    }]

  },

  // {

  //   path: '/general-knowledge-migration',

  //   component: Layout,

  //   children: [{

  //     path: '/general-knowledge-migration',


  //     name: 'GeneralKnowledgeMigration',

  //     component: () => import('@/views/admin/GeneralKnowledgeMigration.vue'),

  //     meta: { title: '通用知识点迁移', visible: false, roles: ['admin'], icon: 'el-icon-refresh' }

  //   }]

  // },

  // 机构管理路由

  {

    path: '/org',

    component: Layout,

    redirect: '/org/dashboard',

    meta: { title: '机构管理', icon: 'el-icon-office-building', roles: ['organization'], hideSidebar: true },

    children: [

      {

        path: 'dashboard',

        name: 'OrgDashboard',

        component: () => import('@/views/organization/OrgDashboard.vue'),

        meta: { title: '机构首页', icon: 'el-icon-s-home', visible: true, roles: ['organization'], hideSidebar: true }

      },

      {

        path: 'users',

        name: 'OrgUsers',

        component: () => import('@/views/organization/OrgUsers.vue'),

        meta: { title: '推广用户', icon: 'el-icon-user', visible: true, roles: ['organization'], hideSidebar: true }

      },

      {

        path: 'orders',

        name: 'OrgOrders',

        component: () => import('@/views/organization/OrgOrders.vue'),

        meta: { title: '购买记录', icon: 'el-icon-s-order', visible: true, roles: ['organization'], hideSidebar: true }

      },

      {

        path: 'courses',

        name: 'OrgCourses',

        component: () => import('@/views/organization/OrgCourses.vue'),

        meta: { title: '课程管理', icon: 'el-icon-notebook-2', visible: true, roles: ['organization'], hideSidebar: true }

      },

      {

        path: 'teachers',

        name: 'OrgTeachers',

        component: () => import('@/views/organization/OrgTeachers.vue'),

        meta: { title: '教师管理', icon: 'el-icon-user', visible: true, roles: ['organization'], hideSidebar: true }

      },

      {

        path: 'courses/:courseId',

        name: 'OrgCourseDetail',

        component: () => import('@/views/organization/OrgCourseDetail.vue'),

        meta: { title: '课程详情', icon: 'el-icon-notebook-2', visible: false, roles: ['organization'], hideSidebar: true }

      },

      {

        path: 'settings',

        name: 'OrgSettings',

        component: () => import('@/views/organization/OrgSettings.vue'),

        meta: { title: '机构设置', icon: 'el-icon-setting', visible: true, roles: ['organization'], hideSidebar: true }

      }

    ]

  },

  {

    path: '/gesp-practice',

    name: 'GESPPractice',

    hidden: true,

    component: () => import('@/views/gesp/GESPPractice.vue'),

    meta: { title: 'GESP答题', visible: false, roles: ['student', 'admin', 'teacher'] }

  },

  // 通配符路由必须放在最后

  { path: '*', redirect: '/404', hidden: true }

]

const createRouter = () => new Router({

  // mode: 'history', // require service support

  scrollBehavior: () => ({ y: 0 }),

  routes: constantRoutes

})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465

export function resetRouter() {
  const newRouter = createRouter()

  router.matcher = newRouter.matcher // reset router
}

export default router
